// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import AddCompetitionExpenses from '../addCompetitionExpense';
import FlatButton from 'material-ui/FlatButton';

class ViewCompetitionRegistration extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id:props.competition_id,
      registration_details:[],
      data_uploaded: false,
      data_error: false,
      addExpenseView:false,
      billView:false,
      bill_source:'',
    };
    
    this.getExpenseDetail = this.getExpenseDetail.bind(this);
    
  }

  componentDidMount() {
    this.getExpenseDetail();
    console.log(this.state);
  }

  getExpenseDetail() {
        const url = `${getLocationOrigin()}/tournament/get_competition_registrations/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({registration_details: data.registration_details, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  onViewBill(bill_source){
    this.setState({billView:!this.state.billView,bill_source:bill_source})
  }


  render() {
    const okaction = <input type="button" className="button1" value="OK" onClick={() => {this.onViewBill()}} /> ;
    console.log(this.state)
    return(
      <div>
        { this.state.registration_details.length > 0 && 
            <div className="col-md-8" style={styles.table} >
                 <div className="col-md-12" style={styles.sub_header}> Registrations </div> 
                <table className="table_plain" >
                          <tr>
                                <th>Date </th>
                                <th>Costumer </th>
                                <th>Name </th>
                                <th>Mobile No. </th>
                                <th>Email </th>
                          </tr> 
                      { this.state.registration_details.map((registration,index) =>
                      <tr key={index}>
                        <td>{registration.created_on} </td>
                        <td>{registration.customer} </td>
                        <td>{registration.name}</td>
                        <td>{registration.contact_number}</td>
                        <td>{registration.email_id}</td>
                      </tr>
                      )}
                    </table>
            </div>

        }
      </div>
    );
  }
}

export default ViewCompetitionRegistration;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionRegistration/index.js